import { render, staticRenderFns } from "./ThreadChildReplies.vue?vue&type=template&id=52dcc69a&scoped=true&"
import script from "./ThreadChildReplies.vue?vue&type=script&lang=js&"
export * from "./ThreadChildReplies.vue?vue&type=script&lang=js&"
import style0 from "./ThreadChildReplies.vue?vue&type=style&index=0&id=52dcc69a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dcc69a",
  null
  
)

/* custom blocks */
import block0 from "./ThreadChildReplies.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports